// extracted by mini-css-extract-plugin
export default {"model":"Model_model__ZNiZO","model__view":"Model_model__view__Wo7oA"};